module.exports = __webpack_public_path__ + "static/media/mini_yoda.11686791.png";